export const SURVEYS_ID = {
  FAVORITE_SCHOOLS: 1,
  FAVORITE_MAJORS: 2,
};

export const FAVORITE_SCHOOLS_QUESTION_ID = {
  FIRST: '1',
  SECOND: '2',
  THIRD: '3',
  FOURTH: '4',
};

export const FAVORITE_MAJORS_QUESTION_ID = {
  FIRST: '1',
  SECOND: '2',
  THIRD: '3',
};

export const SCORE_DATA = [
  { value: '1', label: 'Strongly disagree' },
  { value: '2', label: 'Disagree' },
  { value: '3', label: 'Neutral' },
  { value: '4', label: 'Agree' },
  { value: '5', label: 'Strongly agree' },
];

export const SCHOOL_QUESTIONS_DATA = [
  {
    id: FAVORITE_SCHOOLS_QUESTION_ID.FIRST,
    title: 'This school offers a program of study that interests me and would prepare me well for my future career.',
    scoreData: SCORE_DATA,
    notSureMessage:
      'No worries. Look back at your aptitude matches and see what interests you or chat with your school counselor.',
  },
  {
    id: FAVORITE_SCHOOLS_QUESTION_ID.SECOND,
    title: 'Financially, I would be able to afford this school.',
    scoreData: SCORE_DATA,
  },
  {
    id: FAVORITE_SCHOOLS_QUESTION_ID.THIRD,
    title: 'This school would provide opportunities for me to explore my non-academic interests.',
    scoreData: SCORE_DATA,
    notSureMessage: 'A great way to get a sense of a school is to take a tour of the campus.',
  },
];
